export enum SourceIds {
  CreditKarma = 'KARMA_00',
  Experian = 'EXP_00',
  ExperianPrefill = 'EXP_MAT',
  DirectMail = 'DM_00',
  Reinstatement = 'REIN_00',
  Starling = 'SPRW_00',
}
